// CMS content may store an absolute MCL URL. These two hosts represent the same
// application in different environments; iframe targets should use the build's host.
export function resolveMclViewerUrl(uri, baseUri) {
    let source;
    try {
        source = new URL(uri.startsWith("//") ? "https:" + uri : uri);
    }
    catch {
        return uri;
    }
    if (!["http:", "https:"].includes(source.protocol) ||
        !["mcl2.boyden.net", "mclprime.boyden.net"].includes(source.hostname) ||
        source.port || source.username || source.password) {
        return uri;
    }
    const destination = new URL(baseUri);
    destination.pathname = source.pathname;
    destination.search = source.search;
    destination.hash = source.hash;
    return destination.href;
}
